import React from 'react';
import { BookOpen, Sparkles } from 'lucide-react';
import { motion } from 'framer-motion';
const items = [<>
    <strong className="text-white font-bold block mb-1 text-xl" data-id="element-200">
      Crear videos UGC auténticos
    </strong>
    <span className="text-white/70 text-base" data-id="element-201">
      que generan CIENTOS de ventas para las marcas 💸
    </span>
  </>, <>
    <strong className="text-white font-bold block mb-1 text-xl" data-id="element-202">
      Grabar, editar y estructurar
    </strong>
    <span className="text-white/70 text-base" data-id="element-203">
      tus videos paso a paso como una Creadora PRO 🎬
    </span>
  </>, <>
    <strong className="text-white font-bold block mb-1 text-xl" data-id="element-204">
      Armar tu portfolio profesional
    </strong>
    <span className="text-white/70 text-base" data-id="element-205">
      utilizando mis plantillas exclusivas y probadas 📁
    </span>
  </>, <>
    <strong className="text-white font-bold block mb-1 text-xl" data-id="element-206">
      Trabajar con marcas top
    </strong>
    <span className="text-white/70 text-base" data-id="element-207">
      sin necesidad de experiencia previa ni miles de seguidores 🤝
    </span>
  </>];
export function LearnSection() {
  return <section className="px-6 py-8 flex flex-col items-center text-center max-w-7xl mx-auto" data-id="element-208">
      <div className="w-full max-w-5xl relative rounded-[2.5rem] p-[2px] bg-gradient-to-r from-[#D98BAF]/50 via-brand-pinkDark to-[#D98BAF]/50 shadow-[0_20px_50px_-15px_rgba(217,139,175,0.3)]" data-id="element-209">
        <div className="bg-[#0d0d12] rounded-[2.4rem] p-6 md:p-10 relative overflow-hidden flex flex-col items-center" data-id="element-210">
          {/* Ambient glow */}
          <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-[#D98BAF]/15 via-transparent to-transparent pointer-events-none" data-id="element-211" />

          <div className="inline-flex items-center gap-2 bg-[#D98BAF]/10 border border-[#D98BAF]/30 text-[#D98BAF] font-bold text-[12px] md:text-sm uppercase tracking-[0.2em] px-6 py-2.5 rounded-full mb-8 backdrop-blur-sm relative z-10" data-id="element-212">
            <BookOpen size={16} strokeWidth={2.5} data-id="element-213" />
            El conocimiento exacto
          </div>

          <h2 className="font-serif font-bold text-3xl md:text-5xl text-white mb-14 leading-tight relative z-10" data-id="element-214">
            ¿Qué vas a{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#D98BAF] to-[#fce7f1]" data-id="element-215">
              aprender
            </span>
            ?
          </h2>

          <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 text-left relative z-10" data-id="element-216">
            {items.map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: i * 0.1
          }} className="bg-white/[0.02] border border-white/10 rounded-3xl p-8 flex items-start gap-5 hover:bg-white/[0.04] hover:border-[#D98BAF]/40 transition-all group" data-id="element-217">
                <div className="w-12 h-12 shrink-0 rounded-2xl bg-gradient-to-br from-[#D98BAF] to-brand-pinkDark flex items-center justify-center shadow-[0_0_20px_rgba(217,139,175,0.4)] group-hover:scale-110 transition-transform" data-id="element-218">
                  <span className="text-white font-black text-xl" data-id="element-219">{i + 1}</span>
                </div>
                <div className="flex flex-col" data-id="element-220">{item}</div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}